module.exports = __webpack_public_path__ + "5420a033cba9653770221403feb7de6c.png";